import api from '@/utils/api';

/**
 * Get a quote pdf by id and type (quote or enquiry)
 * @param {string} quoteId - The quote id
 * @param {string} type - The type of the quote
 * @returns {Promise}
 */
const getQuotePdfApi = (quoteId, type) =>
  api.get(`/quote/pdf/${quoteId}/${type}`);

export default getQuotePdfApi;
